export function Square({ text, isMarked, onMark }) {
  return (
    <div className="square" onClick={() => onMark(text)}>
      {isMarked ? <div className="marker" /> : null}
      <span className={sizeClass(text)}>{text}</span>
    </div>
  );
}

function sizeClass(text) {
  if (text.length > 30) {
    return "sm";
  }
  if (text.length > 15 || (text.length > 10 && text.indexOf(" ")) < 0) {
    return "md";
  } else {
    return "lg";
  }
}
